import React from 'react';
import { useStyles } from './AssessmentList.styles';
import { Grid, Typography } from '@material-ui/core';
import AllTasksAssessedIcon from '../../../assets/icons/all-tasks-assessed.svg';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import TooltipOne from '../../TooltipOne/TooltipOne.component';

interface EmptyTaskListProps {
  viewType: 'cards' | 'solutions';
  activeTaskNo?: string;
  onTaskChange: (value: 'next' | 'previous') => void;
}

export const EmptyTasksList: React.FC<EmptyTaskListProps> = (props) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.emptyTaskListContainer}>
      <Grid item xs={12} className={classes.padded}>
        <img src={AllTasksAssessedIcon} alt="ikona wszystkie zadania ocenione" />
      </Grid>
      <Grid item xs={12} className={classes.padded}>
        <Typography className={classes.emptyTaskListText}>
          {props.viewType === 'cards'
            ? 'W tej chwili nie posiadasz żadnych nieocenionych zadań w tej karcie.'
            : `W tej chwili nie posiadasz nieocenionego zadania ${
                props.activeTaskNo ? props.activeTaskNo : ''
              } w tej karcie.`}
        </Typography>
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={2} className={classes.padded}>
        <TooltipOne title="Poprzednie nieocenione zadanie" placement="top">
          <NavigateBeforeIcon className={classes.pointer} onClick={() => props.onTaskChange('previous')} />
        </TooltipOne>
      </Grid>
      <Grid item xs={2} className={classes.padded}>
        <TooltipOne title="Następne nieocenione zadanie" placement="top">
          <NavigateNextIcon className={classes.pointer} onClick={() => props.onTaskChange('next')} />
        </TooltipOne>
      </Grid>
      <Grid item xs={4} />
    </Grid>
  );
};
